<template>
  <div class="settlein-list-cont">
    <titleHeader :hide-nav="true" title="我要入驻">
      <van-icon name="plus" size="20" v-if="" @click="gotoSettle" />
    </titleHeader>
    <div class="settle-list" v-for="(item, index) in settleInList">
      <div>
        <span>申请时间：</span>
        <span>{{item.createAt}}</span>
      </div>
      <div>
        <span>审核时间：</span>
        <span>{{item.modifyAt}}</span>
      </div>
      <div>
        <span>审核结果：</span>
        <span>{{item.result}}</span>
      </div>
    </div> 
    <div class="no-data" v-if="nodata">暂无申请记录</div>
  </div>
</template>
<script>
  import api from 'api/user';
  export default {
    data() {
      return {
        settleInList: [],
        nodata: false
      }
    },
    computed:{
      isSupplier() { //是否已入驻商城
        return this.$store.state.userInfo.userType === 2
      }
    },
    created() {
      this.getSettleList()
    },
    methods: {
      getSettleList() {
        api.getSettleRecord()
          .then(res => {
            console.log(res)
              this.settleInList = res;
            if (res.length > 0) {
              this.nodata = false;
            }else{
              this.nodata = true;
            }
          })
      },
      //前往入驻
      gotoSettle() {
        this.$router.push({
          name: 'settleIn'
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .settle-list{
    padding: 10px;
    font-size: 16px; 
    border-bottom: 1px solid #d8d4d4;
  }
  .no-data{
    margin-top: 20px;
    text-align: center;
    color: red;
  }
</style>